import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=f169c0a4"
import script from "../services/delete.js?vue&type=script&lang=js&external"
export * from "../services/delete.js?vue&type=script&lang=js&external"
import style0 from "../assets/css/teacher/detail-teacher.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports